import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {stringToDigits, stringStripNonCaps} from '../../../../../utils/formatting';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

import RhinoCheckbox from '../../../../common/inputs/RhinoCheckbox';

class CheckboxList extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    let initValues = [];
    if(this.props.initData) {
      initValues = this.props.initData;
    }

		this.state = {
      allSelected: initValues.length == 'all',
      selectedValues: initValues,
    };
	}

	componentDidMount() {

  }

  componentDidUpdate(prevProps, prevState) {
    if(this.props.resetElement != prevProps.resetElement) {
      this.resetData();
    }
  }

  resetData() {
    let initValues = [];
    if(this.props.initData) {
      initValues = this.props.initData;
    }

    this.state = {
      allSelected: initValues.length == 'all',
      selectedValues: initValues,
    };
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  getSelectAllValue() {
    let returnArray = [];

    for(let i = 0; i < this.props.checkboxData.length; i++) {
      returnArray.push(this.props.checkboxData[i].value);
    }
    return returnArray;
  }

  // Depricated since we no longer have combined (color & carat) "Metal Type" filters
  getDataKeys(keyVal) {
    if(keyVal == "METAL_COMPOUND") {
      return ["metal", "metalcarat"];
    } if(keyVal == 'cut') {
      return ['cutMin', 'cutMax'];
    } else {
      return [ keyVal ];
    }
  }

  getDataValues(dataVal) {
    if(this.props.dataKey == "METAL_COMPOUND") {
      return [ 
        this.getMetalValues(dataVal), 
        this.getMetalCaratValues(dataVal), 
      ];
    } else {
      return [ dataVal ];
    }
  }

  getMetalValues(dataStr) {
    let valArray = dataStr.split(',');
    let returnArray = [];
    for(let i = 0; i < valArray.length; i++) {
      if(stringStripNonCaps(valArray[i]) != '') {
        returnArray.push(stringStripNonCaps(valArray[i]));
      }
    }
    return [...new Set(returnArray)].join(",");
  }

  getMetalCaratValues(dataStr) {
    let valArray = dataStr.split(',');
    let returnArray = [];
    for(let i = 0; i < valArray.length; i++) {
      if(stringToDigits(valArray[i]) != '') {
        returnArray.push(stringToDigits(valArray[i]));
      }
    }
    return [...new Set(returnArray)].join(",");
  }

  toggleAll() {

    this.setState({
      allSelected: !this.state.allSelected,
      selectedValues: !this.state.allSelected === true ? this.getSelectAllValue() : [],
    }, () => {
      this.props.refreshData(this.props.productType, this.getDataKeys(this.props.dataKey), this.getDataValues(this.state.selectedValues.join(",")));
    });
  }

  toggleValue(evt) {

    let radioValue = evt.target.value;
    let newValues = [];
    let shouldInsert = !this.state.selectedValues.includes(radioValue);

    for(let i = 0; i < this.state.selectedValues.length; i++) {
      
      if(radioValue != this.state.selectedValues[i]) {
        newValues.push(this.state.selectedValues[i]);
      }
    }

    if(shouldInsert) {
      newValues.push(radioValue);
    }

    this.setState({
      selectedValues: newValues,
    }, () => {

      if(this.props.dataKey !== 'cut') {
        if(this.state.selectedValues.length == this.props.checkboxData.length) {
          this.setState({ allSelected: true }, () => {
            this.props.refreshData(this.props.productType, this.getDataKeys(this.props.dataKey), this.getDataValues(this.state.selectedValues.join(",")));
          });
        } else {
          this.setState({ allSelected: false }, () => {
            this.props.refreshData(this.props.productType, this.getDataKeys(this.props.dataKey), this.getDataValues(this.state.selectedValues.join(",")));
          });
        }
      } else {
        let cutMin = this.state.selectedValues.includes('VG') ? 'VG' : (this.state.selectedValues.includes('EX') ? 'EX' : 'VG');
        let cutMax = this.state.selectedValues.includes('EX') ? 'EX' : (this.state.selectedValues.includes('VG') ? 'VG' : 'EX');
        this.props.refreshData(this.props.productType, this.getDataKeys(this.props.dataKey), [ cutMin, cutMax ]);
      }
    });
  }


	render() {
		return <div className='CheckboxList'>
      {this.props.disclaimer ?
        <div className='checkboxDisclaimer'>{this.props.disclaimer}</div> :
        null
      }
			<div className='checkboxListWrapper'>
        <div className='checkboxItem' style={this.props.disableAll ? { display: 'none' } : {}}>
          <div className='boxWrapper'>
            <RhinoCheckbox
              changeMethod={::this.toggleAll}
              selected={this.state.allSelected} />
          </div>
          <div className='itemLabel'>All {this.props.label}</div>
        </div>
        <div className='checkboxHr' style={this.props.disableAll ? { display: 'none' } : {}}></div>
        {this.props.checkboxData.map((datum, i) => {
          return <div className='checkboxItem' key={i}>
            <div className='boxWrapper'>
              <RhinoCheckbox 
                changeMethod={::this.toggleValue} value={i}
                selected={this.state.selectedValues.includes(datum.value) || this.state.allSelected}
                disabled={this.props.disabled}
                value={datum.value} />
            </div>
            <div className='itemLabel'>{datum.name}</div>
          </div>;
        })}
      </div>
		</div>;
	}
}
export default CheckboxList;

function mapStateToProps(state) {
  return {

  };
}

export const CheckboxListContainer = connect(
  mapStateToProps,
  allActionCreators
)(CheckboxList);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/filterElements/CheckboxList.jsx